export function getEquipmentChangeFormInitialValues(currentTractor: string, currentTrailer: [string, string]) {
  return {
    tractor_number: currentTractor || undefined,
    trailer_ids: [
      {
        trailer_config: currentTrailer?.[0]
          ? {
              label: `${currentTrailer[0]} (${currentTrailer[1] || 'N/A'})`,
              value: serializeTrailerValue(currentTrailer),
            }
          : undefined,
      },
    ],
  }
}

export function serializeTrailerValue(trailerConfig: [string, string]) {
  return JSON.stringify({ trailer_number: trailerConfig[0], trailer_type: trailerConfig[1] })
}

export function deserializeTrailerValue(serializedValue: string | undefined): SelectedTrailerConfig {
  if (!serializedValue) return { trailer_number: null, trailer_type: null }
  try {
    const parsed = JSON.parse(serializedValue) as { trailer_number: string; trailer_type: string }
    return parsed
  } catch (error) {
    return { trailer_number: null, trailer_type: null }
  }
}
